import {EventPoint} from './event-point';
export class Event {
    locationDate: string;
    points: EventPoint[] = [];
}